import { Card, Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';

function Tasks() {
  return (
    <>
      <Skeleton variant="text" className="h-5 w-16 mr-4 mb-4 pt-2 mt-7" />
      <Card className="bg-[white] pt-3 pr-6 pb-3 pl-6" radius="lg">
        <Skeleton variant="text" className="h-5 w-full" />
        {[...Array(8)].map((_, index) => (
          <div className="flex items-center mt-5 justify-between" key={index}>
            <div className="flex w-full w-1/2">
              <Skeleton variant="circle" size="xs" className="mr-3" />
              <Skeleton variant="text" className="h-5 w-1/2" />
            </div>
            <Skeleton variant="text" className="h-5 w-1/4" />
          </div>
        ))}
      </Card>
    </>
  );
}

export default observer(Tasks);
